export default __webpack_public_path__ + "static/media/METAHERO.ab8587f4.svg";